import { HttpTimeoutError, UnknownError } from '@cian/peperrors/shared';
import { Response as HttpApiResponse } from './Response.js';
export class Request {
    isDestroyed = false;
    requestConfig;
    timeout;
    requestServerName;
    responseType;
    request;
    reject;
    constructor(params) {
        this.requestConfig = params.requestConfig;
        this.timeout = params.timeout;
        this.requestServerName = params.requestServerName || params.requestConfig.url.host;
        this.responseType = params.responseType;
    }
    async send() {
        return this.makeRequestPromise();
    }
    makeRequestPromise() {
        return new Promise((resolve, reject) => {
            const { url, withCredentials, method, headers, body } = this.requestConfig;
            const stringUri = url.toString();
            this.reject = reject;
            this.request = new XMLHttpRequest();
            this.request.addEventListener('load', () => {
                const responseData = this.request.response.byteLength > 0 ? this.request.response : null;
                const response = new Response(responseData, {
                    status: this.request.status,
                    statusText: this.request.statusText,
                });
                resolve(new HttpApiResponse({
                    reqConfig: this.requestConfig,
                    rawHeaders: this.request.getAllResponseHeaders(),
                    response,
                    statusCode: this.request.status,
                    responseType: this.responseType,
                }));
            });
            this.request.addEventListener('timeout', () => {
                reject(new HttpTimeoutError(`Microservice ${this.requestServerName} api ${stringUri} not answers in ${this.timeout} milliseconds`, `http-api.request-timeout.${this.requestServerName}`));
            });
            this.request.addEventListener('error', () => reject(new UnknownError({
                message: `Microservice ${this.requestServerName} api ${stringUri} request error`,
                domain: `http-api.request-error.${this.requestServerName}`,
            })));
            this.request.open(method, stringUri, true);
            this.request.timeout = this.timeout;
            this.request.withCredentials = withCredentials;
            headers.toArray().forEach(([name, value]) => this.request.setRequestHeader(name, value));
            this.request.responseType = 'arraybuffer';
            // TODO: null - это старый код, необходимо проверить, что можно без него
            this.request.send(body || null);
        });
    }
    destroy(err) {
        if (this.request) {
            this.isDestroyed = true;
            this.request.abort();
            this.reject(err);
        }
    }
}
//# sourceMappingURL=Request.js.map